import React, { Component, PropTypes } from 'react'
import { translate } from 'react-i18next'
import { Fonts, Metrics, Colors } from '../../Themes'
import Input from '../../components/Input'
import Button from '../../components/Button'
import HvbWhite from '../../svg-icons/HvbWhite'
import styled from 'styled-components'
import AuthActions from '../../actions/AuthActions'
import AuthStore from '../../stores/AuthStore'
import adminBackgroundImage from '../../../public/img/Landing/adminBackgroundImage.png'

const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  min-width: 750px;
  display: table;
  text-align: center;
  backgroundColor: ${Colors.darkGrey};
  background: url(${adminBackgroundImage}) no-repeat center;
  background-size: cover;
  min-width: ${Metrics.components.adminScreensMinWidth};
  overflow-x: scroll;
`

const Content = styled.div`
  height: 100%;
  width: 100%;
  display: table-cell;
  vertical-align: middle;
`

const LogoContainer = styled.div`
  width: 130px;
  margin-left: calc((100% - 130px)/2)
  margin-bottom: 30px;
`

const LoginBox = styled.div`
  display: block;
  width: 515px;
  min-height: 358px;
  max-height: 515px;
  padding: 40px 95px;
  margin: 0 auto;
  overflow-y: scroll;
  backgroundColor: ${Colors.white};
`

const CustomInput = styled(Input)`
  margin-top: ${Metrics.margins.large};
  .inputTitle {
    color: ${Colors.primary};
  }
`

const Title = styled.div`
  ${Fonts.style.Title};
  color: ${Colors.primary};
`

const ErrorMessage = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')}
  margin: ${Metrics.margins.small} 0;
  ${Fonts.style.Small};
  color: ${Colors.red};
`

const LoginButton = styled(Button)`
  margin-top: ${Metrics.margins.larger};
`

class LoginAdmin extends Component {
  constructor (props) {
    super(props)
    this.state = {
      email: '',
      password: ''
    }
    this.handleLogin = this.handleLogin.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handlePasswordChange = this.handlePasswordChange.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  componentWillUpdate (nextProps, nextState) {
    if (!this.props.admin && nextProps.admin) {
      this.props.router.replace('/admin')
    }
  }

  static getInitialState () {
    return AuthStore.getState()
  }

  static getStores () {
    return [ AuthStore ]
  }

  static getPropsFromStores () {
    let authState = AuthStore.getState()
    return {
      admin: authState.admin,
      fetching: authState.fetching,
      errorMessage: authState.errorMessage
    }
  }

  handleEmailChange (event) {
    let value = event.target.value
    this.setState({ email: value })
  }

  handlePasswordChange (event) {
    let value = event.target.value
    this.setState({ password: value })
  }

  handleLogin () {
    let { email, password } = this.state
    AuthActions.loginAdmin(email, password)
  }

  handleKeyPress (event) {
    if (event.key === 'Enter') {
      this.handleLogin()
    }
  }

  render () {
    const { t } = this.props
    let { errorMessage } = this.props
    return (
      <main>
        <PageContainer>
          <Content>
            <LogoContainer>
              <HvbWhite />
            </LogoContainer>
            <LoginBox>
              <Title>{t('Admin')}</Title>
              <CustomInput
                type={'email'}
                title={t('E-mail')}
                handleChange={this.handleEmailChange}
              />
              <CustomInput
                type={'password'}
                title={t('Password')}
                handleChange={this.handlePasswordChange}
                handleKeyPress={this.handleKeyPress}
              />
              <ErrorMessage visible={errorMessage}>{errorMessage}</ErrorMessage>
              <LoginButton label={t('Log in')} onClick={this.handleLogin} />
            </LoginBox>
          </Content>
        </PageContainer>
      </main>
    )
  }
}

LoginAdmin.propTypes = {
  t: PropTypes.func,
  errorMessage: PropTypes.string,
  admin: PropTypes.object,
  router: PropTypes.object
}

export default translate([ 'common', 'landing' ], { wait: true })(LoginAdmin)



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/index.js